import {
   COLOR_REACTION_INFO,DELETE_COLOR_REACTION,IS_LOADING_LIST_OF_COLORS_REACTIONS,CREATE_COLOR_REACTION,IS_LOADING_COLOR_REACTION,
    EDIT_COLOR_REACTION,LIST_OF_COLORS_REACTIONS
} from '../actions/types'

const initialState = {
 
    isLoadingListColorsReaction:false,
    listColorsReaction:[],
    isLoadingColorReaction:false,
    colorReactionInfo:{} 

}


export default function (state = initialState, action) {
    switch (action.type) {

case IS_LOADING_LIST_OF_COLORS_REACTIONS:
    return { ...state, isLoadingListColorsReaction: true }
case  CREATE_COLOR_REACTION:
    var addColorReaction = state.listColorsReaction
    addColorReaction.push(action.payload)
    return { ...state, listColorsReaction: addColorReaction, isLoadingListColorsReaction: false } 
case EDIT_COLOR_REACTION:
    console.log()
    var editColorReaction = state.listColorsReaction
    editColorReaction[action.payload.index] = action.payload.data
    return { ...state, listColorsReaction: editColorReaction, isLoadingListColorsReaction: false }
case LIST_OF_COLORS_REACTIONS:
    return { ...state, isLoadingListColorsReaction: false, listColorsReaction: action.payload }
case IS_LOADING_COLOR_REACTION:
    return { ...state, isLoadingColorReaction:true }
case COLOR_REACTION_INFO:
    return { ...state, colorReactionInfo:action.payload,isLoadingColorReaction:false }
case DELETE_COLOR_REACTION:
    var deleteColorReaction = state.listColorsReaction
    deleteColorReaction.splice(action.payload, 1)
    return { ...state, isLoadingListColorsReaction: false, listColorsReaction: deleteColorReaction }
    default:
        return state

}
}

